import { defaultPageMetaConfig, PageMetaConfig } from '@spartacus/core';

const resolvers = defaultPageMetaConfig.pageMeta?.resolvers ?? [];

export const customPageMetaConfig: PageMetaConfig = {
  pageMeta: {
    resolvers: [
      ...resolvers,
      {
        property: 'hrefLangs',
        method: 'resolveHrefLangs'
      }
    ],
    canonicalUrl: {
      forceHttps: true,
      forceWww: false,
      removeQueryParams: false,
      forceTrailingSlash: false
    }
  }
};
